import React from 'react';
import SvgIconDPC from "../dpc-svg-icon";

export default class LanguageButtonDPC extends React.Component {

    selectedLanguage = typeof window !== `undefined` ? (this.props.lang === 'it' ? 'ITA' : 'ENG') : null;

    getPathLanguage = (lingua, slug) => {
        this.selectedLanguage = lingua === 'it' ? 'ITA' : 'ENG';
        if (slug) {
            slug = slug.charAt(0) === '/' ? `${slug.slice(1)}` : slug;
            if (typeof window !== `undefined` ? (window.location.pathname.split("/")[1] !== lingua) : null) {
                return `/${lingua}/${slug}`;
            } else if (typeof window !== `undefined` ? (window.location.pathname.split("/")[1] === lingua) : null) {
                return `${typeof window !== `undefined` ? window.location.pathname : null}/`;
            }
        } else {
            return `/${lingua}/`;
        }
    };

    render() {
        return (
            <div className="it-header-slim-wrapper">
                <div className="container">
                    <div className="it-header-slim-wrapper-content">
                        <a href="#main" className="sr-only sr-only-focusable">Vai al contenuto principale</a>
                        <a href="#footer" className="sr-only sr-only-focusable">Raggiungi il piè di pagina</a>
                        {/*
                        this.props.superHeader?.title ?
                        <a href={this.props.superHeader.link} target='_blank' rel='noreferrer'>{this.props.superHeader.title}</a>
                        :null
                        */}
                        <div className="it-header-slim-right-zone ml-auto">                  
                            <div className="it-socials d-none d-xl-flex"> 
                                <ul>     
                                    <li>
                                        <a href="https://www.facebook.com/iononrischio/"
                                            title="Pagina Facebook della campagna di Io non rischio"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'facebook'} color={"#475047"}/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/io_non_rischio/"
                                            title="Profilo della campagna Io non rischio su Instagram"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'instagram'} color={"#475047"}/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/iononrischio"
                                            title="Segui la campagna di Io non rischio su Twitter"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'twitter'} color={"#475047"}/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.youtube.com/channel/UCdOg4quMoJDjQIkopcXkqCQ"
                                            title="Canale YouTube della campagna Io non rischio"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'youtube'} color={"#475047"}/>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.flickr.com/photos/196243517@N02/albums"
                                            title="Album Flickr della campagna Io non rischio"
                                            target="_blank" rel="noreferrer">
                                            <SvgIconDPC name={'flickr'} color={"#475047"}/>
                                        </a>
                                    </li>
                                                
                                </ul>  
                            </div>
                            <div className="nav-item dropdown lang-selector">
                                <a className="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
                                   aria-expanded="false">
                                    <span>{this.selectedLanguage}</span>
                                    <SvgIconDPC name='expand' aria-hidden="true" color={"#475047"}/>
                                </a>
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="link-list-wrapper">
                                                <ul className="link-list">
                                                    <li><a className="list-item" href='#' onClick={() =>
                                                        typeof window !== `undefined` ? (window.location.pathname = this.getPathLanguage(
                                                            'it',
                                                            this.props.slugTraduzione
                                                        )) : null
                                                    }
                                                    ><span>ITA</span></a></li>
                                                    <li><a className="list-item" href='#' onClick={() =>
                                                        typeof window !== `undefined` ? (window.location.pathname = this.getPathLanguage(
                                                            'en',
                                                            this.props.slugTraduzione
                                                        )) : null
                                                    }
                                                    ><span>ENG</span></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
